export default "__VITE_ASSET__D_Aj6q$L__"